<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="512"
        height="512"
        x="0"
        y="0"
        viewBox="0 0 24 24"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
        class="">
        <g>
            <path
                d="M19 8.276V7c0-3.86-3.141-7-7-7S5 3.14 5 7v1.276c-1.742.621-3 2.271-3 4.224v7C2 21.981 4.019 24 6.5 24h11c2.481 0 4.5-2.019 4.5-4.5v-7c0-1.953-1.258-3.602-3-4.224ZM6 7c0-3.309 2.691-6 6-6s6 2.691 6 6v1.051c-.166-.019-.329-.051-.5-.051h-11c-.171 0-.334.032-.5.051V7Zm15 12.5c0 1.93-1.57 3.5-3.5 3.5h-11C4.57 23 3 21.43 3 19.5v-7C3 10.57 4.57 9 6.5 9h11c1.93 0 3.5 1.57 3.5 3.5v7Zm-8.5-5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 1 0Z"
                fill="currentColor"
                opacity="1"
                data-original="currentColor"></path>
        </g>
    </svg>
</template>
